import React from "react";
import { Form, Input, Select, DatePicker } from "antd";
import { useTranslation } from "react-i18next";
import { countriesData } from "../../../../constants";
import dayjs from "dayjs";
import { FormInstance } from "antd/lib";
// import {
//   LawsViolationTable,
//   OtherNationalitiesTable,
//   OtherPassportsTable
// } from "../../../../components";

type PersonalInfoProps = {
  form: FormInstance<IVisaRequestFormData>;
  passportData: any;
};

const PersonalInfo: React.FC<PersonalInfoProps> = ({ form, passportData }) => {
  const { t } = useTranslation();

  /*
  The sections for:
  - other passports
  - multiple nationalities
  - laws violation
  are currently commented out in the JSX below.
  Keeping the state/handlers here would trigger ESLint no-unused-vars.
  Uncomment both the JSX section and this block together when re-enabling.

  // Other passports data
  const [showOtherPassports, setShowOtherPassports] = useState<boolean>(
    form.getFieldValue("other_passports")?.length > 0
  );
  const [otherPassports, setOtherPassports] = useState<IOtherPassportInfo[]>(
    form.getFieldValue("other_passports")?.length > 0
      ? form.getFieldValue("other_passports")
      : [
          {
            key: "1",
            passport_number: "",
            fullname: "",
            date_of_birth: "",
            nationality: ""
          }
        ]
  );
  const handleAddOtherPassports = () => {
    const newData: IOtherPassportInfo = {
      key: Date.now().toString(),
      passport_number: "",
      fullname: "",
      date_of_birth: "",
      nationality: ""
    };

    setOtherPassports([...otherPassports, newData]);
    form.setFieldsValue({ other_passports: [...otherPassports, newData] });
  };
  const handleDeleteOtherPassports = (key: string) => {
    const newData = otherPassports.filter((item) => item.key !== key);

    setOtherPassports(newData);
    form.setFieldsValue({ other_passports: newData });
  };
  const handleChangeOtherPassports = (
    key: string,
    field: keyof IOtherPassportInfo,
    value: string
  ) => {
    const newData = otherPassports.map((item) => {
      if (item.key === key) {
        return { ...item, [field]: value };
      }
      return item;
    });

    setOtherPassports(newData);
    form.setFieldsValue({ other_passports: newData });
  };

  // Multiple nationalities data
  const [showMultipleNationalities, setShowMultipleNationalities] =
    useState<boolean>(form.getFieldValue("other_nationalities")?.length > 0);
  const [multipleNationalities, setMultipleNationalities] = useState<
    IOtherNationalitiesInfo[]
  >(
    form.getFieldValue("other_nationalities")?.length > 0
      ? form.getFieldValue("other_nationalities")
      : [
          {
            key: "1",
            country_name: ""
          }
        ]
  );
  const handleAddMultipleNationalities = () => {
    const newData: IOtherNationalitiesInfo = {
      key: Date.now().toString(),
      country_name: ""
    };

    setMultipleNationalities([...multipleNationalities, newData]);
    form.setFieldsValue({
      other_nationalities: [...multipleNationalities, newData]
    });
  };
  const handleDeleteMultipleNationalities = (key: string) => {
    const newData = multipleNationalities.filter((item) => item.key !== key);

    setMultipleNationalities(newData);
    form.setFieldsValue({ other_nationalities: newData });
  };
  const handleChangeMultipleNationalities = (
    key: string,
    field: keyof IOtherNationalitiesInfo,
    value: string
  ) => {
    const newData = multipleNationalities.map((item) => {
      if (item.key === key) {
        return { ...item, [field]: value };
      }
      return item;
    });

    setMultipleNationalities(newData);
    form.setFieldsValue({ other_nationalities: newData });
  };

  // Laws violation data
  const [showLawsViolation, setShowLawsViolation] = useState<boolean>(
    form.getFieldValue("laws_violation")?.length > 0
  );
  const [lawsViolation, setLawsViolation] = useState<ILawsViolationInfo[]>(
    form.getFieldValue("laws_violation")?.length > 0
      ? form.getFieldValue("laws_violation")
      : [
          {
            key: "1",
            act_of_violation: "",
            time_of_violation: "",
            form_of_sanction: "",
            authority_imposed_sanction: ""
          }
        ]
  );
  const handleAddLawsViolation = () => {
    const newData: ILawsViolationInfo = {
      key: Date.now().toString(),
      act_of_violation: "",
      time_of_violation: "",
      form_of_sanction: "",
      authority_imposed_sanction: ""
    };

    setLawsViolation([...lawsViolation, newData]);
    form.setFieldsValue({ laws_violation: [...lawsViolation, newData] });
  };
  const handleDeleteLawsViolation = (key: string) => {
    const newData = lawsViolation.filter((item) => item.key !== key);

    setLawsViolation(newData);
    form.setFieldsValue({ laws_violation: newData });
  };
  const handleChangeLawsViolation = (
    key: string,
    field: keyof ILawsViolationInfo,
    value: string
  ) => {
    const newData = lawsViolation.map((item) => {
      if (item.key === key) {
        return { ...item, [field]: value };
      }
      return item;
    });

    setLawsViolation(newData);
    form.setFieldsValue({ laws_violation: newData });
  };
  */

  return (
    <>
      <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-6">
        <Form.Item
          // initialValue={passportData?.sur_name}
          layout={"vertical"}
          label={
            <label className="text-primary-blue">
              {t("registration_form.step2.surname")}
            </label>
          }
          name="surname"
          style={{ color: "red" }}
          rules={[
            () => ({
              validator(_, value) {
                if (/^[a-zA-Z\s]*$/.test(value)) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    t("registration_form.invalid_name", {
                      ns: "message",
                    })
                  )
                );
              },
            }),
          ]}
        >
          <Input placeholder={t("registration_form.step2.surname_hint")} />
        </Form.Item>

        <Form.Item
          // initialValue={passportData?.given_name}
          layout={"vertical"}
          className="text-primary-blue"
          label={
            <label className="text-primary-blue">
              {t("registration_form.step2.given_name")}
            </label>
          }
          name="middle_and_given_name"
          rules={[
            {
              required: true,
              message: t("registration_form.empty_given_name", {
                ns: "message",
              }),
            },
            () => ({
              validator(_, value) {
                if (/^[a-zA-Z\s]*$/.test(value)) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    t("registration_form.invalid_name", {
                      ns: "message",
                    })
                  )
                );
              },
            }),
          ]}
        >
          <Input placeholder={t("registration_form.step2.given_name_hint")} />
        </Form.Item>

        <Form.Item
          // initialValue={
          //   passportData?.dob ? dayjs(passportData?.dob, "DD/MM/YYYY") : null
          // }
          layout={"vertical"}
          className="text-primary-blue"
          label={
            <label className="text-primary-blue">
              {t("registration_form.step2.date_of_birth")} (DD/MM/YYYY)
            </label>
          }
          name="date_of_birth"
          rules={[
            {
              required: true,
              message: t("registration_form.empty_date_of_birth", {
                ns: "message",
              }),
            },
            () => ({
              validator(_, value) {
                if (value && dayjs().diff(dayjs(value), "year") >= 14)
                  return Promise.resolve();

                return Promise.reject(
                  new Error(
                    t("registration_form.invalid_date_of_birth", {
                      ns: "message",
                    })
                  )
                );
              },
            }),
          ]}
        >
          <DatePicker
            format="DD/MM/YYYY"
            className="w-full"
            placeholder={t("registration_form.step2.date_of_birth_hint")}
          />
        </Form.Item>

        <Form.Item
          // initialValue={passportData?.gender}
          layout={"vertical"}
          className="text-primary-blue"
          label={
            <label className="text-primary-blue">
              {t("registration_form.step2.gender")}
            </label>
          }
          name="gender"
          rules={[
            {
              required: true,
              message: t("registration_form.empty_gender", {
                ns: "message",
              }),
            },
          ]}
        >
          <Select placeholder={t("registration_form.step2.gender_hint")}>
            <Select.Option value="Male">
              {t("registration_form.step2.male")}
            </Select.Option>
            <Select.Option value="Female">
              {t("registration_form.step2.female")}
            </Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          // initialValue={passportData?.nationality}
          layout={"vertical"}
          className="text-primary-blue"
          label={
            <label className="text-primary-blue">
              {t("registration_form.step2.nationality")}
            </label>
          }
          name="nationality"
          rules={[
            {
              required: true,
              message: t("registration_form.empty_nationality", {
                ns: "message",
              }),
            },
          ]}
        >
          <Select
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={countriesData.map((country, index) => ({
              key: index,
              label:
                localStorage.getItem("i18nextLng") === "en"
                  ? country.name
                  : localStorage.getItem("i18nextLng") === "jp"
                  ? country.japaneseName
                  : localStorage.getItem("i18nextLng") === "cn"
                  ? country.chineseName
                  : country.koreanName,
              value: country.code,
            }))}
            placeholder={t("registration_form.step2.nationality_hint")}
          />
        </Form.Item>

        {/* <Form.Item
          layout={"vertical"}
          className="text-primary-blue"
          label={
            <label className="text-primary-blue">
              {t("registration_form.step2.id_number")}
            </label>
          }
          name="id_card"
        >
          <Input placeholder={t("registration_form.step2.id_number_hint")} />
        </Form.Item> */}

        <Form.Item
          layout={"vertical"}
          label={
            <label className="text-primary-blue">
              {t("registration_form.step2.email")}
            </label>
          }
          name="email"
          rules={[
            {
              required: true,
              message: t("registration_form.empty_email", {
                ns: "message",
              }),
            },
            {
              type: "email",
              message: t("registration_form.invalid_email", {
                ns: "message",
              }),
            },
          ]}
        >
          <Input placeholder={t("registration_form.step2.id_number_hint")} />
        </Form.Item>

        <Form.Item
          layout={"vertical"}
          label={
            <label className="text-primary-blue">
              {t("registration_form.step2.confirm_email")}
            </label>
          }
          name="confirm_email"
          dependencies={["email"]}
          rules={[
            {
              required: true,
              message: t("registration_form.empty_confirm_email", {
                ns: "message",
              }),
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("email") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    t("registration_form.invalid_confirm_email", {
                      ns: "message",
                    })
                  )
                );
              },
            }),
          ]}
        >
          <Input
            placeholder={t("registration_form.step2.confirm_email_hint")}
          />
        </Form.Item>

        {/* <Form.Item
          layout={"vertical"}
          label={
            <label className="text-primary-blue">
              {t("registration_form.step2.religion")}
            </label>
          }
          name="religion"
          rules={[
            {
              required: true,
              message: t("registration_form.empty_religion", {
                ns: "message"
              })
            }
          ]}
        >
          <Input placeholder={t("registration_form.step2.religion_hint")} />
        </Form.Item> */}

        <Form.Item
          initialValue={passportData?.place_of_birth}
          layout={"vertical"}
          label={
            <label className="text-primary-blue">
              {t("registration_form.step2.place_of_birth")}
            </label>
          }
          name="place_of_birth"
          rules={[
            {
              required: true,
              message: t("registration_form.empty_place_of_birth", {
                ns: "message",
              }),
            },
          ]}
        >
          <Input
            placeholder={t("registration_form.step2.place_of_birth_hint")}
          />
        </Form.Item>

        {/* <Form.Item
          layout={"vertical"}
          className="flex items-end"
          name="create_account_by_email"
          valuePropName="checked"
        >
          <Checkbox className="text-primary-blue">
            {t("registration_form.step2.create_account")}
          </Checkbox>
        </Form.Item> */}
      </div>

      {/* <div className="space-y-8">
        <div className="flex flex-col border-b-[1px] border-primary-border pb-6">
          <div className="flex max-md:flex-col max-md:gap-4 justify-between mb-4">
            <div className="text-primary-blue">
              {t("registration_form.step2.another_passport")}
            </div>

            <Radio.Group
              className="flex max-md:justify-evenly"
              value={showOtherPassports}
              onChange={(e) => {
                setShowOtherPassports(e.target.value);
                if (!e.target.value) {
                  setOtherPassports([
                    {
                      key: "1",
                      passport_number: "",
                      fullname: "",
                      date_of_birth: "",
                      nationality: ""
                    }
                  ]);
                  form.setFieldsValue({ other_passports: [] });
                }
              }}
            >
              <Radio value={true}>{t("registration_form.yes_option")}</Radio>
              <Radio value={false}>{t("registration_form.no_option")}</Radio>
            </Radio.Group>
          </div>

          {showOtherPassports && (
            <OtherPassportsTable
              dataSource={otherPassports}
              handleChange={handleChangeOtherPassports}
              handleAdd={handleAddOtherPassports}
              handleDelete={handleDeleteOtherPassports}
            />
          )}
        </div>

        <div className="flex flex-col border-b-[1px] border-primary-border pb-6">
          <div className="flex max-md:flex-col max-md:gap-4 justify-between mb-4">
            <div className="text-primary-blue">
              {t("registration_form.step2.multiple_nationalities")}
            </div>

            <Radio.Group
              className="flex max-md:justify-evenly"
              value={showMultipleNationalities}
              onChange={(e) => {
                setShowMultipleNationalities(e.target.value);
                if (!e.target.value) {
                  setMultipleNationalities([
                    {
                      key: "1",
                      country_name: ""
                    }
                  ]);
                  form.setFieldsValue({ other_nationalities: [] });
                }
              }}
            >
              <Radio value={true}>{t("registration_form.yes_option")}</Radio>
              <Radio value={false}>{t("registration_form.no_option")}</Radio>
            </Radio.Group>
          </div>

          {showMultipleNationalities && (
            <OtherNationalitiesTable
              dataSource={multipleNationalities}
              handleChange={handleChangeMultipleNationalities}
              handleAdd={handleAddMultipleNationalities}
              handleDelete={handleDeleteMultipleNationalities}
            />
          )}
        </div>

        <div className="flex flex-col border-b-[1px] border-primary-border pb-6">
          <div className="flex max-md:flex-col max-md:gap-4 justify-between mb-4">
            <div className="text-primary-blue">
              {t("registration_form.step2.violation")}
            </div>

            <Radio.Group
              className="flex max-md:justify-evenly"
              value={showLawsViolation}
              onChange={(e) => {
                setShowLawsViolation(e.target.value);
                if (!e.target.value) {
                  setLawsViolation([
                    {
                      key: "1",
                      act_of_violation: "",
                      time_of_violation: "",
                      form_of_sanction: "",
                      authority_imposed_sanction: ""
                    }
                  ]);
                  form.setFieldsValue({ laws_violation: [] });
                }
              }}
            >
              <Radio value={true}>{t("registration_form.yes_option")}</Radio>
              <Radio value={false}>{t("registration_form.no_option")}</Radio>
            </Radio.Group>
          </div>

          {showLawsViolation && (
            <LawsViolationTable
              dataSource={lawsViolation}
              handleChange={handleChangeLawsViolation}
              handleAdd={handleAddLawsViolation}
              handleDelete={handleDeleteLawsViolation}
            />
          )}
        </div>
      </div> */}
    </>
  );
};

export default PersonalInfo;
